import EventEmitter from 'events';
import { useEffect, useState } from 'react';

let parentWindowURL: string | null = null;
const emitter = new EventEmitter();

export const setParentWindowURL = (nextParentWindowURL: string | null) => {
    parentWindowURL = nextParentWindowURL;
    emitter.emit('parentWindowURLChanged', nextParentWindowURL);
};

export const getParentWindowURL = (): string => {
    if (parentWindowURL) {
        return parentWindowURL;
    }
    if (typeof window === 'undefined') {
        return '';
    }
    return window.parent !== window ? document.referrer : document.location.href;
};

export const useParentWindowURL = () => {
    const [parentWindowURLState, setParentWindowURLState] = useState(getParentWindowURL());
    useEffect(() => {
        const onParentWindowURLChanged = () => {
            setParentWindowURLState(getParentWindowURL());
        };
        emitter.addListener('parentWindowURLChanged', onParentWindowURLChanged);
        return () => {
            emitter.removeListener('parentWindowURLChanged', onParentWindowURLChanged);
        };
    }, []);
    return parentWindowURLState;
};
